import React, { Component } from "react";
import { connect } from "react-redux";
import { Icon } from "semantic-ui-react";
import { Wrapper, SelectDomainsInputWrapper } from "./style.js";
import IconButton from "./../../../../components/IconButton";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import { domains } from "./../../../../modules/magnetDomains";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";

import _ from "lodash";

class DomainSelector extends React.Component {
  constructor(props) {
    super(props);
    this.state.domainCombinationSelected = this.props.domainCombinationSelected;
  }

  state = {};

  handleEntering = () => {
    if (this.props.domainCombinationSelected !== this.state.domainCombinationSelected) {
      this.setState({ domainCombinationSelected: this.props.domainCombinationSelected });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "selected-domains") {
      this.setState({ domainCombinationSelected: value });
    } else {
    }
  };

  handleCancel = () => {
    this.props.onClose(this.props.domainCombinationSelected);
  };

  handleOk = () => {
    if (this.state.domainCombinationSelected !== null) {
      this.props.onClose(this.state.domainCombinationSelected);
    }
  };

  render() {
    const { domainCombinations, ...other } = this.props;
    const { domainCombinationSelected } = this.state;
    const domainCombination = domainCombinations[domainCombinationSelected];
    const usedDomainCombinations= {};

    return (
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        onEntering={this.handleEntering}
        aria-labelledby="simple-dialog-title"
        {...other}
      >
        <DialogTitle id="simple-dialog-title">Select domains</DialogTitle>
        <DialogContent>
          <FormLabel component="legend">Select domains from list</FormLabel>
          <SelectDomainsInputWrapper>
            <TextField
              select
              multiline
              fullWidth
              name="selected-domains"
              helperText="List is sorted from best to worst combinations"
              value={domainCombinationSelected}
              onChange={this.handleChange}
            >
              {domainCombinations.filter(combo => {
                const key = `${combo.domainOne}${combo.domainTwo}${combo.domainThree}${combo.domainFour}`;
                if (usedDomainCombinations[key]) {
                  return false;
                } else {
                  usedDomainCombinations[key] = true;
                  return true;
                }
              }).map((domainCombination, index) => {
                const domainOne = _.find(domains, ["key", domainCombination.domainOne]).fullName;
                const domainTwo = _.find(domains, ["key", domainCombination.domainTwo]).fullName;
                const domainThree = _.find(domains, ["key", domainCombination.domainThree]).fullName;
                const domainFour = _.find(domains, ["key", domainCombination.domainFour]).fullName;
                const domainsText = `${domainOne}, ${domainTwo}, ${domainThree} and ${domainFour}`;
                const percent = Math.floor((domainCombination.pass * 100) / domainCombination.units.length);
                const text = `${percent}% of work settings pass - ${domainsText}`;
                return (
                  <MenuItem key={`${index}-${text}`} value={index}>
                    {text}
                  </MenuItem>
                );
              })}
            </TextField>
          </SelectDomainsInputWrapper>
          {/* <div style={{ paddingTop: "40px" }} /> */}
          {/* <FormGroup>
              <FormLabel component="legend">Or select domains by checkbox</FormLabel>
              {_.map(domains, domain => {
                let isChecked = false;
                if (domainCombination && domainCombination.domainOne === domain.key) {
                  isChecked = true;
                }
                if (domainCombination && domainCombination.domainTwo === domain.key) {
                  isChecked = true;
                }
                if (domainCombination && domainCombination.domainThree === domain.key) {
                  isChecked = true;
                }
                if (domainCombination && domainCombination.domainFour === domain.key) {
                  isChecked = true;
                }
                return (
                  <FormControlLabel
                    control={<Checkbox checked={isChecked} onChange={this.handleChange} />}
                    label={domain.fullName}
                  />
                );
              })}
            </FormGroup> */}
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={this.handleOk} color="primary">
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
    };
    this.toggleShowHide = this.toggleShowHide.bind(this);
    this.handleClickOpen = this.handleClickOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  toggleShowHide() {
    this.setState({ show: !this.state.show });
  }

  handleClickOpen = () => {
    this.setState({
      open: true,
    });
  };

  handleClose = (value) => {
    this.props.setSelectedDomains(value);
    this.setState({
      open: false,
    });
  };

  render() {
    const { domainCombinations, domainCombinationSelected } = this.props;
    const { show } = this.state;
    return (
      <Wrapper className={show ? "" : "hide"}>
        <div className="toggle" onClick={this.toggleShowHide}>
          <Icon name="sliders" />
          <span>Settings</span>
        </div>
        <div className="sidebar-wrapper">
          <div className="sidebar">
            <IconButton icon="close" onClick={this.toggleShowHide} color="black" className="close-button" />
            <div className="header">Options</div>
            <div className="content">
              <Button onClick={this.handleClickOpen} color="primary" variant="contained">
                Select domains
              </Button>
              <DomainSelector
                open={this.state.open}
                onClose={this.handleClose}
                domainCombinations={domainCombinations}
                domainCombinationSelected={domainCombinationSelected}
              />
            </div>
          </div>
        </div>
      </Wrapper>
    );
  }
}
export default connect((store) => {
  return {
    summaryReport: store.summaryReport.summaryReport,
  };
})(Sidebar);



// WEBPACK FOOTER //
// ./src/pages/MagnetReport/components/Sidebar/index.jsx